import React from 'react';
import MenuButton from '../../../../../Common/MenuButton/MenuButton';
import classes from './menu.module.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faRedo, faChalkboardTeacher, faEdit, faFireExtinguisher } from '@fortawesome/free-solid-svg-icons';

const Menu = ({ handleActiveModal }) => {
	return (
		<section className={classes.page}>			
			<div className={classes['menu-column']}>
				<MenuButton
					title="Contract Release Pre EX6"
					icon={() => <FontAwesomeIcon icon={faChalkboardTeacher} size="9x" />}
					width="80%"
					onClick={() => handleActiveModal('pre_ex6')}
				/>
			</div>
			<div className={classes['menu-column']}>
				<MenuButton
					title="Amend Contract"
					icon={() => <FontAwesomeIcon icon={faEdit} size="9x" />}
					width="80%"
					onClick={() => handleActiveModal('amend_contract')}
				/>
			</div>
			<div className={classes['menu-column']}>
				<MenuButton
					title="Contract Release Post EX6"
					icon={() => <FontAwesomeIcon icon={faFireExtinguisher} size="9x" />}
					width="80%"
					onClick={() => handleActiveModal('post_ex6')}
				/>
			</div>
		</section>
	);
};

export default Menu;
